import { Box, Button, Container, Flex, HStack, Link as CLink, Text, type ContainerProps } from '@chakra-ui/react'
import { Link, Outlet } from 'react-router'
import { LuLayoutDashboard } from 'react-icons/lu'
import { ColorModeButton } from '~/components/ColorModeButton'
import { Logo } from '~/components/Logo'

/** Public pages (landing, member portal `/o/:orgSlug/*`, unsubscribe, organizer auth): header + content + footer. */
export const PublicLayout = () => (
  <Flex direction='column' minH='100svh' bg='bg'>
    <Box as='header' borderBottom='1px solid' borderColor='border'>
      <Container maxW='max-content-width' py={3}>
        <Flex alignItems='center' justifyContent='space-between' gap={4}>
          <Link to='/' aria-label='Home'>
            <Logo />
          </Link>
          <HStack gap={2}>
            <ColorModeButton />
            {/* Icon-only on small phones, full label on md+ to prevent header overflow at 390 px */}
            <Button asChild size='sm' variant='outline' colorPalette='gray' aria-label='Organizer dashboard'>
              <Link to='/organizer'>
                <LuLayoutDashboard />
                <Box as='span' display={{ base: 'none', sm: 'inline' }}>
                  Organizer dashboard
                </Box>
              </Link>
            </Button>
          </HStack>
        </Flex>
      </Container>
    </Box>

    <Box as='main' flex='1'>
      <Outlet />
    </Box>

    <Box as='footer' borderTop='1px solid' borderColor='border' py={6} mt={10}>
      <Container maxW='max-content-width'>
        <Flex justifyContent='space-between' gap={4} wrap='wrap' fontSize='sm' color='fg.muted'>
          <Text>
            Anonymous, verifiable voting on{' '}
            <CLink href='https://davinci.vote' target='_blank' rel='noreferrer' color='fg.muted'>
              DAVINCI
            </CLink>{' '}
            · identity verification by{' '}
            <CLink href='https://didit.me' target='_blank' rel='noreferrer' color='fg.muted'>
              Didit
            </CLink>
          </Text>
          <Text>
            <CLink asChild color='fg.muted'>
              <Link to='/privacy'>Privacy</Link>
            </CLink>{' '}
            · Proof of concept · Vocdoni
          </Text>
        </Flex>
      </Container>
    </Box>
  </Flex>
)

/** Narrow centered column for forms and voter steps. */
export const PublicContainer = (props: ContainerProps) => <Container maxW='3xl' py={{ base: 6, md: 10 }} {...props} />
